import { Stack, styled, css, Box, Typography } from '@mui/material';

export const QuotedContainer = styled(Stack)(
  ({ theme }) => css`
    background: ${theme.palette.neutral.var10};
    padding: 0.4rem 0.6rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.4rem;
    border-radius: 0.4rem;
    margin-bottom: 0.4rem;
    cursor: pointer;
  `
);

export const AccentBar = styled(Box)(
  ({ theme }) => css`
    width: 3px;
    align-self: stretch;
    background-color: ${theme.palette.secondary.main};
    border-radius: 2px;
  `
);

export const QuotedContent = styled(Stack)(
  () => css`
    flex: 1;
    min-width: 0;
    overflow: hidden;
  `
);

export const SenderName = styled(Typography)(
  ({ theme }) => css`
    font-weight: 600;
    font-size: 1rem;
    color: ${theme.palette.secondary.main};
  `
);

export const PreviewText = styled(Typography)(
  ({ theme }) => css`
    font-size: 1rem;
    color: ${theme.palette.neutral.var60};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
);
